// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import {getFirestore} from 'firebase/firestore';
import {getStorage} from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQA5zFOGKrTa0zbh77q4amDFy69IOcvhE",
  authDomain: "thechicpics-a5939.firebaseapp.com",
  projectId: "thechicpics-a5939",
  storageBucket: "thechicpics-a5939.appspot.com",
  messagingSenderId: "265625465103",
  appId: "1:265625465103:web:8df1e14ba9224bfa978e7a",
  measurementId: "G-90M7QH8CJR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth=getAuth(app);
export const db=getFirestore(app);
export const storage=getStorage(app);